import { render, staticRenderFns } from "./VersionSelectorMenuElement.vue?vue&type=template&id=090833f0&scoped=true&"
import script from "./VersionSelectorMenuElement.vue?vue&type=script&lang=js&"
export * from "./VersionSelectorMenuElement.vue?vue&type=script&lang=js&"
import style0 from "./VersionSelectorMenuElement.vue?vue&type=style&index=0&id=090833f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090833f0",
  null
  
)

export default component.exports